import React from "react";
import {Stack, Box, alpha} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import PhoneNumber from "@/components/phone-number/phone-number";
import LocaleDropdownMenu from "@/components/locale-selector/locale-dropdown";
import MobileSearchPredictive from "@/components/search-predictive/mobile-search-predictive";
import { Company } from "@/types/contentful/company";
import { NavigationType } from "@/components/header/common/header-enums";
import { Locale } from "@/i18n/routing";

type MobilePrimaryNavigationHeaderProps = {
  locale: Locale;
  currentCompany?: Company;
  setActiveNavigation: (activeNavigation: NavigationType) => void;
};

export default function MobilePrimaryNavigationHeader(props: MobilePrimaryNavigationHeaderProps) {
  const { locale, currentCompany, setActiveNavigation } = props;

  return (
    <Stack
      sx={{
        position: "fixed",
        zIndex: 1000,
        justifyContent: "center",
        width: "100%",
        height: "200px",
        backgroundColor: "var(--isagent-mobile-background-color)"
      }}
    >
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          right: { xs: 8, sm: 13 },
          top: { xs: 20, sm: 28 },
          zIndex: 2,
          cursor: "pointer"
        }}
        onClick={() => setActiveNavigation(NavigationType.base)}
      >
        <CloseIcon
          sx={{
            color: "var(--isagent-text-color)",
            fontSize: { xs: 35, sm: 45 }
          }}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: { xs: 8, sm: 0 },
          left: { xs: 8, sm: 10 },
          zIndex: 1001,
          maxWidth: "80px"
        }}
      >
        <LocaleDropdownMenu />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: { xs: 60, sm: 60 },
          left: { xs: 25, sm: 25 },
          zIndex: 2
        }}
      >
        <PhoneNumber company={currentCompany} locale={locale} />
      </Box>
      <Stack
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            mt: 10,
            width: { xs: "350px", md: "700px" }
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 1.7,
              right: 2,
              zIndex: 1,
              width: 35,
              height: 32,
              border: 1,
              borderColor: (theme) => alpha(theme.palette.common.white, 0.2),
              borderRadius: 2,
              backgroundColor: "secondary.main"
            }}
          >
            <SearchIcon
              sx={{
                color: "secondary.contrastText",
                ml: { xs: .5 },
                mt: { xs: .1, md: .2 },
                fontSize: { xs: 28, md: 28 }
              }}
            />
          </Box>
          <MobileSearchPredictive locale={locale} setActiveNavigation={setActiveNavigation} />
        </Box>
      </Stack>
    </Stack>
  );
}